const state = {
    userInfo: {
        profile: {
            avatarUrl: ''
        }
    },
    userType: '',
}

const mutations = {
    SET_USUER (state, userInfo) {
        state.userInfo = userInfo
        state.userType = userInfo.profile.type
    }
}

const actions = {
}

export default {
    state,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js